export enum ModuleListEnum {
  Default = 'default',
  CaseList = 'case-list',
  Case = 'case-details',
  Customer = 'customer',
}

export interface IModuleContext {
  module: ModuleListEnum
  id?: number

  getUrlParams(): string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getToken(): any
  getActionEndpoint(): string | null
  equals(module: ModuleListEnum, id: number): boolean
}

export class BaseModuleContext implements IModuleContext {
  module = ModuleListEnum.Default
  id?: number

  constructor(id?: number) {
    if (id) this.id = id
  }

  getUrlParams = () => ''
  getToken = () => {}
  getActionEndpoint(): ReturnType<IModuleContext['getActionEndpoint']> {
    return null
  }
  equals = (module: ModuleListEnum, id: number) => {
    return this.module === module && this.id?.toString() === id.toString()
  }
}

export class CaseListModuleContext extends BaseModuleContext {
  module = ModuleListEnum.CaseList
  getActionEndpoint() {
    return `/api/v1/navbar/actions?actionType=HOME`
  }
}
export class CaseModuleContext extends BaseModuleContext {
  module = ModuleListEnum.Case

  getUrlParams = () => `?ticketId=${this.id}`
  getToken = () => ({ ticketId: this.id })
  getActionEndpoint() {
    return `/api/v1/navbar/actions?actionType=EDIT_TICKET&entityInstanceId=${this.id}`
  }
}

export class CustomerModuleContext extends BaseModuleContext {
  module = ModuleListEnum.Customer

  getUrlParams = () => `?customerId=${this.id}`
  getToken = () => ({ customer: this.id })
  getActionEndpoint() {
    return `/api/v1/navbar/actions?actionType=EDIT_CUSTOMER&entityInstanceId=${this.id}`
  }
}
